import React, { useEffect } from "react";
import { setRandomBackground } from "../helpers/backgroundHelpers";
import ContactLinks from "../components/ContactLinks";

const Contact: React.FC = () => {
  useEffect(() => {
    setRandomBackground();
  }, []);

  return (
    <div
      style={{
        padding: "2rem 1.25rem 4rem",
        maxWidth: 900,
        margin: "0 auto",
        color: "#fff",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        lineHeight: 1.45,
      }}
    >
      <header style={{ marginBottom: "2rem" }}>
        <h1 style={{ margin: 0, fontSize: "2.4rem", letterSpacing: "0.5px" }}>
          Contact
        </h1>
        <p style={{ opacity: 0.8, margin: "0.5rem 0 0" }}>
          I'd love to hear from you. Feel free to reach out directly.
        </p>
      </header>

      <section aria-label="Contact links">
        <ContactLinks />
      </section>
    </div>
  );
};

export default Contact;
